module.exports = __webpack_public_path__ + "static/media/acne_leaflet@3x.37dc7bfe.png";